import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-payroll-comment',
  templateUrl: './add-payroll-comment.component.html',
  styleUrls: ['./add-payroll-comment.component.scss'],
})
export class AddPayrollCommentComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AddPayrollCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  onCloseClick(): void {
    this.dialogRef.close(false);
  }
}
